import React from "react";
import { Link } from "react-router-dom";
import BackgroundWrapper from "../components/BackgroundWrapper";


export default function Series2() {
  return (
    <BackgroundWrapper>
      
      <div className="pt-8 pb-20 px-4 min-h-screen">
        <div className="max-w-5xl mx-auto">
          <Link
            to="/enlightened-leadership"
            className="text-blue-600 hover:text-blue-700 font-semibold inline-flex items-center mb-8"
          >
            ← Back to Enlightened Leadership
          </Link>

          <div className="bg-white/90 backdrop-blur-md rounded-3xl shadow-2xl p-10 md:p-16">
            <h1 className="sm:text-3xl text-1xl font-bold text-slate-800 mb-6">
              Series 2 – Leadership and the Good Society
            </h1>

            <p className="sm:text-lg text-sm  text-slate-700 mb-6 leading-relaxed">
              This series explores the role of leadership in shaping just and
              sustainable societies. It introduces the works of great thinkers
              in history related to human nature, liberty, and social equity,
              mapping them to the <strong>Executive Compass</strong> — a model
              combining liberty, equity, efficiency, and sustainability as moral
              dimensions of leadership.
            </p>

            <h2 className="sm:text-lg text-sm  font-semibold text-slate-800 mb-4">Content</h2>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-6">
              <li>Part 1 – Human Nature</li>
              <li>Part 2 – Liberty</li>
              <li>Part 3 – Equity</li>
              <li>Part 4 – Efficiency</li>
              <li>Part 5 – Community and Sustainability</li>
              <li>Part 6 – The Leadership Compass</li>
            </ul>

            <p className="text-slate-700 leading-relaxed mb-4 sm:text-lg text-sm ">
              Through guided discussions and case analyses, leaders develop a
              comprehensive understanding of how societal values influence their
              decision-making and moral stance. The program challenges them to
              align business objectives with social responsibility.
            </p>

            <p className="text-slate-600 text-sm">
              <strong>Method:</strong> Seminar  ·  Group Coaching  ·  Selected Individual Coaching
            </p>
          </div>
        </div>
      </div>
    </BackgroundWrapper>
  );
}
